import request from '@/utils/request'

export function getmitmgkmpList(data) {
  return request({
    url: `/api/mitmgkmp/many`,
    method: 'post',
    data,
  })
}
